/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_register = /** @type {(inputs: {}) => string} */ () => {
	return `Registrovat se`
};

const da_account_register = /** @type {(inputs: {}) => string} */ () => {
	return `Registrer`
};

const de_account_register = /** @type {(inputs: {}) => string} */ () => {
	return `Registrieren`
};

const en_account_register = /** @type {(inputs: {}) => string} */ () => {
	return `Register`
};

const es_account_register = /** @type {(inputs: {}) => string} */ () => {
	return `Registrarse`
};

const fr_account_register = /** @type {(inputs: {}) => string} */ () => {
	return `S'enregistrer`
};

const hu_account_register = /** @type {(inputs: {}) => string} */ () => {
	return `Regisztráció`
};

const it_account_register = /** @type {(inputs: {}) => string} */ () => {
	return `Registrati`
};

const nl_account_register = /** @type {(inputs: {}) => string} */ () => {
	return `Registreren`
};

const pl_account_register = /** @type {(inputs: {}) => string} */ () => {
	return `Zarejestruj się`
};

const pt_account_register = /** @type {(inputs: {}) => string} */ () => {
	return `Registrar`
};

const sv_account_register = /** @type {(inputs: {}) => string} */ () => {
	return `Registrera`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_register = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_register(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_register", locale)
	if (locale === "cs") return cs_account_register(inputs)
	if (locale === "da") return da_account_register(inputs)
	if (locale === "de") return de_account_register(inputs)
	if (locale === "en") return en_account_register(inputs)
	if (locale === "es") return es_account_register(inputs)
	if (locale === "fr") return fr_account_register(inputs)
	if (locale === "hu") return hu_account_register(inputs)
	if (locale === "it") return it_account_register(inputs)
	if (locale === "nl") return nl_account_register(inputs)
	if (locale === "pl") return pl_account_register(inputs)
	if (locale === "pt") return pt_account_register(inputs)
	return sv_account_register(inputs)
};
export { account_register as "account.register" }